import * as React from "react"
import { Link, graphql } from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/seo"

const NotFoundPage = ({ data, location }) => {
  const siteTitle = data.site.siteMetadata.title

  return (
    <Layout location={location} title={siteTitle}>
      <Seo title="Datenschutz" />
      <h1>Die beste Datenschutzerklärung</h1>
      <p>Wir speichern keine Daten. Nichts, wirklich. Keine Cookies, keine Logs, nichts. 
          Sie können gerne zur <Link to="/">Hauptseite zurückkehren</Link> oder die Ruhe hier genießen.
Stand: 10.05.2021 </p>
    </Layout>
  )
}

export default NotFoundPage

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`
